import { graphql, navigate, StaticQuery } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import Logo from '../../../../static/uploads/logo.svg';
import { Subpage } from '../../../interfaces';
import { encodeUri } from '../../../utils/EncodeUri';
import { theme } from '../../../utils/Theme';
import { Tooltip, TooltipWrapper } from './Tooltip';

export interface MarkerPropsNode {
  email: string;
  address: string;
  secondPhone: string;
  firstPhone: string;
  name: string;
}

interface MarkerProps {
  node: MarkerPropsNode;
  lat: number;
  lng: number;
  location: {
    pathname: string;
  };
}

interface queryResponse {
  subpagesJson: Subpage;
}

interface TextWrapperProps {
  current: boolean;
}

const StyledLogo = styled(Logo)`
  width: 50px;
  height: 50px;
  margin-left: 25px;
  margin-top: 15px;
`;

const MarkerWrapper = styled.div`
  width: 100px;
  height: 100px;
  margin-left: -50px;
  margin-top: -50px;
  font-size: 12px;

  &:hover {
    filter: brightness(120%);
    cursor: pointer;
  }

  :hover ${TooltipWrapper} {
    display: block;
  }
`;

const TextWrapper = styled.div<TextWrapperProps>`
  width: 100px;
  text-align: center;
  padding-top: 5px;
  text-shadow: 0px 0px 3px ${theme.colors.white};
  ${({ current }) => current && `color: ${theme.colors.green}`}
`;

const redirectToContactPage = (kindergartenName: string, data: queryResponse) => {
  navigate('/' + encodeUri(kindergartenName) + '/' + data.subpagesJson.url);
};

const isCurrentKindergarten = (props: MarkerProps): boolean => {
  return props.location.pathname.includes(encodeUri(props.node.name));
};

const query = graphql`
  query {
    subpagesJson(key: { eq: "contact" }) {
      url
    }
  }
`;

export const Marker = (props: MarkerProps) => {
  return (
    <StaticQuery
      query={query}
      render={(data: queryResponse) => {
        return (
          <MarkerWrapper onClick={() => redirectToContactPage(props.node.name, data)}>
            <Tooltip node={props.node} />
            <StyledLogo alt="Logo"></StyledLogo>
            <TextWrapper current={isCurrentKindergarten(props)}>{props.node.name}</TextWrapper>
          </MarkerWrapper>
        );
      }}
    />
  );
};
